var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('div',{staticClass:"hero-title mb-4 px-4 px-sm-12",class:{
      'text-center white--text': _vm.isMobile,
      'text-left': !_vm.isMobile,
      'mt-12': _vm.isMobile,
    },style:(_vm.isMobile ? '' : 'text-shadow: 3px 1px 20px rgba(0, 0, 0, 0.5)')},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]),_c('div',{class:{
      'mb-': _vm.isMobile,
    }},[_c('div',{staticClass:"hero-subtitle px-4 px-sm-12",class:{
        'text-center white--text': _vm.isMobile,
        'text-left': !_vm.isMobile,
        'mx-auto': _vm.isMobile,
        'mb-8': _vm.isMobile,
      },staticStyle:{"line-height":"1.5"},style:(_vm.isMobile ? '' : 'text-shadow: 3px 1px 20px rgba(0, 0, 0, 0.5)'),domProps:{"textContent":_vm._s(_vm.subtitle)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }